import { io } from 'socket.io-client'

/* Init Socket connexion */

import * as dotenv from 'dotenv'
dotenv.config()

export const socket = io(process.env.SERVER_URL)
